export default __webpack_public_path__ + "static/media/google-gmail.e2cc71f3.svg";